export const VALIDGUESSES = [
'afera',
'agent',
'alarm',
'album',
'alžir',
'anđeo',
'aorta',
'arena',
'aroma',
'arsen',
'astma',
'atlas',
'autor',
'avion',
'azija',
'bačva',
'badem',
'bager',
'bahat',
'bajan',
'bajka',
'bakar',
'balet',
'balon',
'banda',
'banka',
'barem',
'barok',
'barut',
'bašća',
'basen',
'basna',
'batak',
'bazen',
'bazga',
'bečki',
'bedro',
'berba',
'berem',
'beret',
'beton',
'bezub',
'biber',
'bijeg',
'bijem',
'bijes',
'bilje',
'birač',
'biser',
'bitan',
'bitka',
'bitno',
'bivol',
'bivši',
'blago',
'blato',
'blaži',
'bliže',
'bliži',
'blizu',
'bluza',
'bočni',
'bodem',
'bodež',
'bogat',
'bokal',
'bolje',
'bolji',
'bomba',
'borac',
'borba',
'bosna',
'bosti',
'božić',
'božji',
'braća',
'brada',
'brati',
'brava',
'bravo',
'breza',
'briga',
'brkat',
'brlog',
'bruka',
'bruto',
'bučan',
'budan',
'budem',
'bujan',
'bukva',
'bunar',
'bunda',
'burek',
'burma',
'burza',
'čađav',
'čajni',
'čamac',
'časni',
'čavao',
'čedan',
'čekić',
'ćelav',
'celer',
'čelik',
'čepić',
'češće',
'češka',
'češki',
'cesta',
'često',
'četka',
'čičak',
'cifra',
'cigan',
'cigla',
'cigle',
'cijev',
'cikla',
'cimer',
'cimet',
'čipka',
'čisto',
'čitač',
'čitak',
'citat',
'čitav',
'čitko',
'civil',
'čizma',
'cloud',
'čoban',
'čopor',
'ćošak',
'crkva',
'crnac',
'crnji',
'crnka',
'crtač',
'crven',
'čudak',
'čudan',
'čudno',
'ćufte',
'čupav',
'čuvar',
'čvrst',
'dadem',
'dakle',
'đakon',
'dalek',
'dalje',
'dalji',
'danak',
'danas',
'daska',
'dativ',
'datum',
'đavao',
'davni',
'davno',
'debeo',
'deblo',
'dečko',
'dekan',
'demon',
'deset',
'desni',
'desno',
'devet',
'dijel',
'dinar',
'dinja',
'dišni',
'divan',
'divno',
'djeca',
'djelo',
'dlaka',
'dobar',
'dobit',
'dobro',
'doček',
'dodir',
'dojam',
'dokad',
'dokaz',
'dokle',
'dolar',
'dolje',
'domet',
'donji',
'dosad',
'doseg',
'dosje',
'dosta',
'dotad',
'dotle',
'dovod',
'dovoz',
'draga',
'dragi',
'drago',
'draži',
'droga',
'drugi',
'drvce',
'drven',
'drvni',
'drzak',
'dubok',
'đubre',
'dućan',
'dugme',
'duhan',
'dulje',
'dunav',
'dunja',
'dupin',
'dupli',
'dušik',
'đuveč',
'dužan',
'dvije',
'dvoje',
'džaba',
'džbun',
'džudo',
'efekt',
'ekipa',
'ekran',
'ekser',
'elita',
'epski',
'eskim',
'etapa',
'etika',
'farma',
'firma',
'flaša',
'flert',
'fonem',
'forma',
'fosil',
'fraza',
'frula',
'funta',
'gadno',
'gajba',
'galeb',
'gazda',
'gđica',
'gipko',
'glađi',
'glava',
'glina',
'gluma',
'glupo',
'gluši',
'gnjev',
'gnjil',
'golem',
'golub',
'gorak',
'gorko',
'gošća',
'gospa',
'gotov',
'govor',
'građa',
'grana',
'grbav',
'grčka',
'grčki',
'greda',
'gripa',
'griva',
'grlić',
'grozd',
'gruda',
'grudi',
'grupa',
'gubav',
'gudač',
'gumen',
'gusar',
'gušći',
'guska',
'gužva',
'hajde',
'haker',
'harfa',
'heroj',
'hihot',
'himna',
'hitac',
'hitan',
'hitno',
'hlače',
'hmelj',
'hokej',
'hotel',
'hrana',
'hrast',
'hrčak',
'hrvat',
'humor',
'hvala',
'ideja',
'idila',
'idući',
'igdje',
'igrač',
'ikada',
'ikako',
'ikona',
'imati',
'imela',
'imidž',
'inače',
'ipad®',
'ipod®',
'irska',
'ishod',
'iskra',
'ispad',
'ispis',
'ispit',
'ispod',
'ištem',
'istok',
'istra',
'izaći',
'izbor',
'izdah',
'izdam',
'izlaz',
'izlet',
'izlog',
'iznad',
'iznos',
'izraz',
'izrez',
'izuti',
'izvan',
'izvod',
'izvor',
'izvoz',
'jadan',
'jadno',
'jahač',
'jahta',
'jajni',
'jakna',
'jamac',
'janje',
'japan',
'jarac',
'jarki',
'jasan',
'jasle',
'jasno',
'javno',
'javor',
'jecaj',
'ječam',
'jedan',
'jedem',
'jedno',
'jedro',
'jedva',
'jelen',
'jesam',
'jesen',
'jeste',
'jesti',
'jetra',
'jezik',
'jeziv',
'jučer',
'junad',
'junak',
'jutro',
'južni',
'kabel',
'kadar',
'kajak',
'kakao',
'kakav',
'kalež',
'kalup',
'kamen',
'kanal',
'kanta',
'kapak',
'kaput',
'karaš',
'karta',
'kasno',
'kavez',
'kazna',
'kečap',
'kičma',
'kifla',
'kinez',
'kipar',
'kiseo',
'klapa',
'klasa',
'klati',
'klaun',
'kleći',
'klima',
'kliše',
'ključ',
'kljun',
'klupa',
'koban',
'kocka',
'kokos',
'kokoš',
'kolac',
'kolač',
'kolaž',
'kolut',
'komad',
'kombi',
'konop',
'kopar',
'kopča',
'kopno',
'korak',
'korov',
'korpa',
'korzo',
'kotac',
'kotač',
'kotao',
'kovač',
'kozji',
'kožni',
'kraći',
'krađa',
'kralj',
'krava',
'krcat',
'krčma',
'kreda',
'krema',
'krhak',
'krilo',
'krist',
'kriti',
'kriva',
'krivo',
'kriza',
'kršan',
'krsni',
'krući',
'kruna',
'krvav',
'krvni',
'krzno',
'kubik',
'kućni',
'kugla',
'kuhan',
'kuhar',
'kumče',
'kunem',
'kunić',
'kupac',
'kupač',
'kupka',
'kupon',
'kupus',
'kurje',
'kurva',
'kvaka',
'kvart',
'kvota',
'kvrga',
'kzzso',
'labav',
'labud',
'lagan',
'lakat',
'lakši',
'lampa',
'lanac',
'lasta',
'lavež',
'lažan',
'lažem',
'leden',
'leđni',
'leglo',
'letak',
'letva',
'ležaj',
'lički',
'lijek',
'lijen',
'lijep',
'lijes',
'liker',
'limen',
'limun',
'lisac',
'lišće',
'lista',
'litar',
'litra',
'ljeti',
'ljeto',
'ljući',
'ljudi',
'ljuto',
'ločem',
'logor',
'lokal',
'lokot',
'lokva',
'lonac',
'lopov',
'lopta',
'losos',
'lovac',
'lovor',
'lučki',
'luđak',
'lukav',
'lutka',
'mačak',
'mačji',
'mačka',
'mačke',
'madež',
'magla',
'majka',
'makar',
'malen',
'mamac',
'manje',
'manji',
'marka',
'marš!',
'maser',
'maska',
'masno',
'mašta',
'mažem',
'mećem',
'meden',
'mekan',
'mekši',
'melem',
'menza',
'mesar',
'mesni',
'mesti',
'metak',
'metal',
'metan',
'metar',
'metem',
'metla',
'mijem',
'milen',
'milja',
'minus',
'miran',
'miraz',
'miris',
'mirno',
'misao',
'mišić',
'mišji',
'mjera',
'mlači',
'mlada',
'mlađi',
'mnogi',
'mnogo',
'moćan',
'model',
'modni',
'mokar',
'mokro',
'molba',
'molim',
'momak',
'moral',
'motiv',
'motka',
'motor',
'mozak',
'možda',
'mrena',
'mreža',
'mrkva',
'mrlja',
'mršav',
'mrsko',
'mrtav',
'mrtvo',
'mrzak',
'mučan',
'mučno',
'mudar',
'munja',
'musav',
'muški',
'muško',
'mutan',
'muzej',
'muzem',
'nabor',
'način',
'nacrt',
'nadut',
'nafta',
'nagao',
'naglo',
'nagon',
'naići',
'naime',
'najam',
'nakit',
'nakon',
'nalaz',
'nalet',
'nalik',
'nalog',
'napad',
'napet',
'napon',
'napor',
'narav',
'narod',
'nasip',
'nazad',
'naziv',
'nećak',
'nekad',
'nemar',
'nemir',
'nemoć',
'nepce',
'nepun',
'nerad',
'nered',
'nesem',
'nešto',
'netko',
'nevin',
'nijem',
'nikad',
'nisam',
'niski',
'ništa',
'nitko',
'nizak',
'njega',
'njiva',
'njutn',
'noćas',
'noćni',
'nokat',
'nomad',
'norma',
'nosni',
'novac',
'nožić',
'nožni',
'nulti',
'nužan',
'nužda',
'nužno',
'obala',
'obići',
'obiti',
'objed',
'oblak',
'oblik',
'oblog',
'oboje',
'obraz',
'obred',
'obris',
'obrok',
'obruč',
'obrva',
'obuća',
'obući',
'obuka',
'obuti',
'obzir',
'očevi',
'očito',
'odaja',
'odati',
'odbor',
'odgoj',
'odjek',
'odjel',
'odmah',
'odmor',
'odnos',
'odora',
'odraz',
'odred',
'odsad',
'odvod',
'odvoz',
'oganj',
'oglas',
'oklop',
'okolo',
'okret',
'okrug',
'okuka',
'okvir',
'olako',
'olovo',
'oltar',
'oluja',
'omjer',
'onako',
'onamo',
'ondje',
'opeći',
'opeka',
'opera',
'opiti',
'oprez',
'opseg',
'orati',
'organ',
'ormar',
'oseka',
'oslić',
'osoba',
'oštar',
'ostve',
'osuda',
'osvrt',
'oteći',
'oteti',
'otići',
'otkad',
'otkaz',
'otkud',
'otkup',
'otpis',
'otpor',
'otrag',
'otrem',
'otrov',
'otvor',
'ovako',
'ovčar',
'ovčji',
'ovdje',
'oveći',
'ovisi',
'oviti',
'ovlaš',
'ovrha',
'ovuda',
'pačji',
'padež',
'pakao',
'paket',
'palac',
'palma',
'pamet',
'pamuk',
'panda',
'papa!',
'papak',
'papar',
'papir',
'parog',
'pasji',
'pasta',
'pasti',
'patak',
'patka',
'pauza',
'pčela',
'pečat',
'pečen',
'peder',
'pegla',
'pehar',
'pekar',
'pelin',
'pelud',
'penal',
'pepeo',
'perad',
'perec',
'perje',
'perla',
'peron',
'perut',
'petak',
'pijan',
'pilot',
'pisac',
'pisač',
'pismo',
'pista',
'pitak',
'pitom',
'pjega',
'pjena',
'plaća',
'plašt',
'plava',
'plavi',
'plaža',
'pleme',
'plići',
'plima',
'ploča',
'pluća',
'pluto',
'podao',
'podij',
'podlo',
'podne',
'pogan',
'pogon',
'pohan',
'pohod',
'pojam',
'pojas',
'pokop',
'pokus',
'polje',
'pomoć',
'ponoć',
'ponor',
'ponos',
'popis',
'poput',
'poraz',
'pored',
'porez',
'poriv',
'porod',
'porok',
'posao',
'pošta',
'posto',
'pošto',
'posve',
'potez',
'potok',
'potom',
'potop',
'pouka',
'povez',
'povod',
'požar',
'poziv',
'pozor',
'prase',
'prati',
'prava',
'pravi',
'pravo',
'preci',
'preći',
'preči',
'preko',
'prema',
'prgav',
'prhut',
'priča',
'prići',
'prije',
'princ',
'prišt',
'prkos',
'proba',
'proći',
'prost',
'proza',
'prsni',
'pršut',
'prvak',
'pseći',
'psiha',
'psina',
'ptica',
'pučki',
'puder',
'pumpa',
'punac',
'punđa',
'pupak',
'puran',
'pušač',
'puška',
'putar',
'putni',
'račic',
'račun',
'račve',
'radio',
'radni',
'ragbi',
'ralje',
'rasti',
'ratar',
'ratni',
'raudi',
'ravan',
'ravno',
'razan',
'razni',
'razno',
'razum',
'rebro',
'redak',
'redar',
'redni',
'reket',
'remen',
'reuma',
'rezač',
'režem',
'režim',
'ribar',
'ribič',
'riječ',
'ritam',
'rizik',
'rjeđi',
'robot',
'rođak',
'rođen',
'roman',
'rožić',
'ručak',
'ručje',
'ručka',
'ručni',
'rudar',
'rugač',
'ruglo',
'rujan',
'rukat',
'rukav',
'rulja',
'rulni',
'rumen',
'runda',
'ruski',
'ruter',
'ružan',
'ružin',
'ružno',
'sabor',
'safir',
'sajam',
'saldo',
'salon',
'samac',
'šamar',
'samrt',
'šansa',
'santa',
'šapat',
'sapun',
'šaraf',
'šaran',
'šaren',
'sarma',
'šašav',
'saten',
'satni',
'šator',
'sažet',
'scena',
'šećer',
'sedam',
'sedlo',
'sedmi',
'šegrt',
'sekta',
'senat',
'seoba',
'seoce',
'sepsa',
'šerif',
'šešir',
'šesti',
'šetač',
'shema',
'sibir',
'sidro',
'sifon',
'šifra',
'sijed',
'silno',
'sinoć',
'šipak',
'šipka',
'sirće',
'širok',
'sirov',
'sirup',
'sisar',
'sitan',
'sitno',
'sjati',
'sjeći',
'sjeme',
'sjena',
'skala',
'škare',
'skela',
'skele',
'skica',
'skija',
'skije',
'sklad',
'sklon',
'sklop',
'škoda',
'škola',
'skoro',
'škrga',
'škrob',
'skroz',
'skupa',
'skuša',
'slabo',
'slađi',
'slajd',
'slama',
'slana',
'slast',
'slati',
'slava',
'slika',
'slina',
'šljem',
'sloga',
'slovo',
'sluga',
'smeće',
'smjel',
'smjer',
'smoci',
'smola',
'smrad',
'snaga',
'snaha',
'snaša',
'šnita',
'snovi',
'sobar',
'sobni',
'sočan',
'šofer',
'šogor',
'sokol',
'šolja',
'sonet',
'sorta',
'špaga',
'splav',
'sporo',
'sport',
'sprej',
'srati',
'srbin',
'srčan',
'srčem',
'sreća',
'stado',
'staja',
'štajg',
'štaka',
'štala',
'stari',
'staro',
'stati',
'staza',
'steći',
'štene',
'šteta',
'stići',
'štiti',
'štivo',
'stoga',
'stoka',
'stopa',
'stoti',
'strah',
'stran',
'stric',
'strka',
'strog',
'stroj',
'strop',
'struk',
'stuba',
'štuka',
'stvar',
'stvor',
'sućut',
'sudac',
'sudar',
'suđen',
'sukob',
'sulud',
'šumar',
'sunce',
'šunka',
'super',
'surla',
'surov',
'sušen',
'suton',
'sutra',
'svađa',
'svaki',
'svako',
'sveca',
'sveti',
'svici',
'svila',
'svjež',
'svoja',
'švorc',
'svota',
'svrha',
'svući',
'svuda',
'taban',
'tabla',
'tačke',
'tadli',
'tajna',
'tajno',
'takav',
'taksi',
'takvo',
'talas',
'talog',
'taman',
'tanak',
'tanji',
'tarem',
'tašta',
'tavan',
'tečaj',
'tečan',
'tekst',
'telad',
'tempo',
'tenis',
'tenor',
'tepih',
'teren',
'teret',
'teško',
'tetak',
'tetka',
'težak',
'tigar',
'tikva',
'tinta',
'tipka',
'tisak',
'tjeme',
'tkati',
'tkivo',
'točac',
'točan',
'točka',
'točno',
'tolik',
'tonik',
'topao',
'toplo',
'torba',
'trava',
'trbuh',
'trčem',
'treće',
'treći',
'trema',
'trend',
'trice',
'triko',
'trkač',
'trnci',
'trnje',
'troje',
'trska',
'truba',
'truli',
'tulum',
'tumač',
'tumor',
'tunel',
'turbo',
'turci',
'tutor',
'tužba',
'tužno',
'tvoga',
'tvrđi',
'ubiti',
'ubrus',
'ubrzo',
'učiti',
'učmao',
'udaja',
'udati',
'udica',
'ugled',
'ugriz',
'uklet',
'ukras',
'ulica',
'uliti',
'uljez',
'uloga',
'ulozi',
'umiti',
'unija',
'unuče',
'unuka',
'uopće',
'upala',
'upiti',
'upola',
'uprem',
'uputa',
'ureći',
'urlik',
'urota',
'ušiti',
'usjev',
'uskrs',
'uspon',
'usput',
'usred',
'ustav',
'usuti',
'utrem',
'utrka',
'utući',
'uvala',
'uviti',
'uvjet',
'uvući',
'uzdah',
'uzduž',
'uzeti',
'uzgoj',
'uzgon',
'uzica',
'užici',
'užina',
'uživo',
'uzlat',
'uzmem',
'uzrok',
'uzvik',
'vagon',
'vajar',
'vapca',
'varka',
'vatra',
'važan',
'važem',
'važno',
'večer',
'vedar',
'vedro',
'velik',
'vepar',
'veseo',
'veslo',
'vezan',
'vičem',
'viđen',
'video',
'vijak',
'vijek',
'vinar',
'virus',
'viski',
'visok',
'vitak',
'vitez',
'vjera',
'vješt',
'vlada',
'vlaga',
'vlast',
'voćka',
'voćni',
'voden',
'vodič',
'vodik',
'vojna',
'vojni',
'vokal',
'volan',
'volja',
'vosak',
'vozač',
'vozni',
'vrana',
'vrata',
'vreća',
'vrelo',
'vreva',
'vrpca',
'vrsta',
'vrtić',
'vrtni',
'vruće',
'vučem',
'vučji',
'vunen',
'žabac',
'začin',
'zadah',
'zađem',
'zahod',
'zakon',
'žalac',
'žalba',
'zamka',
'žamor',
'zanat',
'zanos',
'zapad',
'zapis',
'zarez',
'žarki',
'zasad',
'zašto',
'zatim',
'zavod',
'zavoj',
'zbrka',
'zbroj',
'žbuka',
'ždera',
'ždral',
'zdrav',
'zebem',
'zebra',
'zečić',
'zečji',
'žedan',
'zelen',
'želiš',
'želja',
'zelje',
'ženik',
'ženka',
'žešći',
'žeton',
'žetva',
'žežem',
'zglob',
'žičan',
'zidar',
'zidić',
'zidni',
'židov',
'žilav',
'žilet',
'zimus',
'žitni',
'živac',
'život',
'zlato',
'žlica',
'zloba',
'zloća',
'zmija',
'žmura',
'znači',
'znati',
'žnjem',
'zomio',
'zoran',
'zospc',
'zovem',
'zraka',
'zrnce',
'žrtva',
'žrtve',
'zubar',
'zubat',
'zubni',
'žubor',
'župni',
'žuran',
'žurno',
'zvati',
'zvono',
]